import { useQuery } from '@tanstack/react-query'
import { QUERY } from '../api/DishConfigurationAPI.model'
import DishConfigurationAPI from '../api/DishConfigurationAPI'

export function useDishConfigurationQuery(dishId?: string) {
  const dish = useQuery({
    queryKey: [QUERY.DISH, dishId!],
    queryFn: () => DishConfigurationAPI.getDish(dishId!),
    enabled: typeof dishId === 'string' && dishId.length > 0
  }).data

  const dishSizesList = useQuery({
    queryKey: [QUERY.DISH_SIZES],
    queryFn: DishConfigurationAPI.getDishSizes
  }).data

  const toppingsList = useQuery({
    queryKey: [QUERY.TOPPINGS],
    queryFn: DishConfigurationAPI.getToppings
  }).data

  return {
    dish,
    dishSizesList,
    toppingsList
  }
}
